import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

/*const routes = [
  { path: '/:id?', name: 'Home', component: Home },
  { path: '/event/:id?/:adaccount_id/:campaign_id?', name: 'Event', component: () => import('../views/Event.vue') },
  { path: '/events-list/:id?/:adaccount_id/:campaign_id?', name: 'List', component: () => import('../views/List.vue') },
  { path: '/msg/:id?/:adaccount_id/:campaign_id?', name: 'Msg', component: () => import('../views/Msg.vue') },
  { path: '/form/:id?/:adaccount_id/:campaign_id?', name: 'Form', component: () => import('../views/Form.vue') },
  { path: '/report/:id?/:adaccount_id/:campaign_id?', name: 'Report', component: () => import('../views/Report.vue') }
]*/

const routes = [
  {
    path: '/trial-bind/:type?/:id?',
    name: 'TrialBindCard',
    component: () => import('../views/TrialBindCard.vue')
  },
  {
    path: '/onboarding-link-account/:type?/:id?',
    name: 'OnboardingLinkAccount',
    component: () => import('../views/OnboardingLinkAccount.vue')
  },
  {
    path: '/:type?/:id?',
    name: 'Home',
    component: Home
  },
  {
    path: '/event-add/:type?/:id/:adaccount_id?',
    name: 'EventAdd',
    component: () => import('../views/EventAdd.vue')
  },
  {
    path: '/event/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'Event',
    component: () => import('../views/Event.vue')
  },
  {
    path: '/event-browse/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'EventBrowse',
    component: () => import('../views/EventBrowse.vue')
  },
  {
    path: '/event-add-tiktok/:type?/:id/:adaccount_id?',
    name: 'EventAddTiktok',
    component: () => import('../views/EventAddTiktok.vue')
  },
  {
    path: '/event-tiktok/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'EventTiktok',
    component: () => import('../views/EventTiktok.vue')
  },
  {
    path: '/event-browse-tiktok/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'EventBrowseTiktok',
    component: () => import('../views/EventBrowseTiktok.vue')
  },
  {
    path: '/events-list/:type?/:id?/:adaccount_id?',
    name: 'List',
    component: () => import('../views/List.vue')
  },
  {
    path: '/customize-events-list/:type?/:id?/:adaccount_id?',
    name: 'CustomizeList',
    component: () => import('../views/CustomizeList.vue')
  },
  {
    path: '/customize-event-add/:type?/:id/:adaccount_id?',
    name: 'CustomizeEventAdd',
    component: () => import('../views/CustomizeEventAdd.vue')
  },
  {
    path: '/customize-event/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'CustomizeEvent',
    component: () => import('../views/CustomizeEvent.vue')
  },
  {
    path: '/customize-event-browse/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'CustomizeEventBrowse',
    component: () => import('../views/CustomizeEventBrowse.vue')
  },
  {
    path: '/strategy-event/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'StrategyEvent',
    component: () => import('../views/StrategyEvent.vue')
  },
  {
    path: '/msg/:id?/:adaccount_id?/:campaign_id?',
    name: 'Msg',
    component: () => import('../views/Msg.vue')
  },
  {
    path: '/form/:id?/:adaccount_id?/:campaign_id?',
    name: 'Form',
    component: () => import('../views/Form.vue')
  },
  {
    path: '/report/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'Report',
    component: () => import('../views/Report.vue')
  },
  {
    path: '/viedo/:type?/:id?',
    name: 'Video',
    component: () => import('../views/Video.vue')
  },
  {
    path: '/audience-center/:type?/:id?',
    name: 'AudienceCenter',
    component: () => import('../views/AudienceCenter.vue')
  },
  {
    path: '/news/:type?/:id?',
    name: 'News',
    component: () => import('../views/News.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router

